import {IListingTypology} from "@wikicasa/common/model/ListingTypology";
import {defaultMultiListingTypologyDTO, MultiListingTypology} from "@wikicasa/common/model/MultiListingTypology";
import {ListingGroup} from "@wikicasa/common/model/ListingGroup";
//@ts-ignore
import {defaultSelectedListingTypologies} from "@wikicasa/common/model/MultiListingTypology";
import {reactive, toRefs, computed} from "vue";
import type {ToRefs, ComputedRef} from "vue"
//@ts-ignore
import {decodeTextWithEntities} from "@utils/StringUtils";

interface UsableLTMSState {
    selectedDTO: MultiListingTypology;
    groups: ListingGroup[];
    originalLabel: string;
    init: boolean;
}

interface UsableLMTS extends ToRefs<UsableLTMSState> {
    labels: ComputedRef<Record<string, string>>;
    selectedLabel: ComputedRef<string>;
    decodeTextWithEntities: typeof decodeTextWithEntities,
    updateSelected: (value: [number], listingTypologies: [IListingTypology], macroTypologyId: number, macroTypologyIdList: number[]) => void;
    updateLabelAndIcon: (listingTypologies: [IListingTypology]) => void;
    generateGroups: (listingTypologies: [IListingTypology]) => void;
    getListingTypologyById: (listingTypologies: [IListingTypology], id: number) => IListingTypology;
    manageListingTypology: (listingTypologies: [IListingTypology], listingTypology: IListingTypology) => void;
    addListingTypology: (lt: IListingTypology) => void;
    isSelected: (lt: IListingTypology) => boolean;
    confirm: (hide: boolean, scroll: boolean, listingTypologies: [IListingTypology]) => void;
    noGroupTypologiesIdList: (listingTypologies: [IListingTypology]) => Array<number>;
}

//IMP: Up to now [14/08/23] this composable is used with the option API, so the input
//     parameter is equal to the context. When the components that use the Option API
//     will be migrated to the Composition API, we will need to make some fixes, so it
//     works with an emit object
export function useListingTypologyMultiselect(emits: any): UsableLMTS {
    const state = reactive<UsableLTMSState>({
        selectedDTO: defaultMultiListingTypologyDTO(),
        groups: [],
        originalLabel: "",
        init: true
    })

    const labels = computed((): Record<string, string> => window["_labels"])
    const selectedIDS = computed((): Array<number> => state.selectedDTO.selectedListingTypologies.map((lt: IListingTypology) => lt.listingTypologyId))
    const groupURL = computed((): string => state.groups.filter((gr: ListingGroup) => gr.id === state.selectedDTO.macroTypologyID)[0]?.url || "")
    const selectedLabel = computed((): string => state.selectedDTO.label)

    const updateSelected = (value: [number], listingTypologies: [IListingTypology], macroTypologyId: number, macroTypologyIdList: number[]): void => {
        if (macroTypologyIdList && state.init && !value) {
            state.selectedDTO.macroTypologyIdList = macroTypologyIdList.length >= 1 ? macroTypologyIdList : []
        }

        if (!state.selectedDTO || !value)
            return

        state.selectedDTO.selectedListingTypologies = listingTypologies.filter(lt => value.includes(lt.listingTypologyId));
        state.selectedDTO.macroTypologyID = macroTypologyId;
        if (groupURL.value)
            state.selectedDTO.groupURL = groupURL.value;
        else
            state.selectedDTO.groupURL = state.selectedDTO.url;
        state.selectedDTO.group = state.selectedDTO.selectedListingTypologies[0].group;
        updateLabelAndIcon(listingTypologies);
        state.originalLabel = state.selectedDTO.label;
    }
    const setOpenedGroup = (groupUrl: string, scroll = false): void => {
        state.groups.forEach(gr => gr.url === groupUrl ? gr.opened = true : gr.opened = false);
        if (scroll) {
            const groupDiv = document.getElementById(`heading_${groupUrl}`);
            groupDiv?.scrollIntoView({behavior: "smooth", block: "nearest", inline: "end"});
        }
    }
    const updateLabelAndIcon = (listingTypologies: [IListingTypology]): void => {
        if (state.selectedDTO.macroTypologyIdList && state.selectedDTO.macroTypologyIdList?.length > 1 && state.init) {
            state.init = false
            state.selectedDTO.label = labels.value["allTypologies"]
        } else if (state.selectedDTO.selectedListingTypologies.length == 1) {
            if (isNoGroupListingTypology(listingTypologies, state.selectedDTO.selectedListingTypologies[0])) {
                state.selectedDTO.label = `${state.selectedDTO.selectedListingTypologies[0].label}`;
                state.selectedDTO.groupURL = `${state.selectedDTO.selectedListingTypologies[0].url}`;
            } else if (isAnyListingTypology(listingTypologies, state.selectedDTO.selectedListingTypologies[0])) {
                state.selectedDTO.label = `${state.selectedDTO.group} - ${state.selectedDTO.selectedListingTypologies[0].label}`;
                state.selectedDTO.groupURL = `${state.selectedDTO.selectedListingTypologies[0].url}`;
            } else {
                state.selectedDTO.label = `${state.selectedDTO.selectedListingTypologies[0].label}`;
                state.selectedDTO.groupURL = `${state.selectedDTO.groupURL}`;
            }
        } else if (state.selectedDTO.selectedListingTypologies.length > 1) {
            state.selectedDTO.groupURL = groupURL.value;
            const macroTypology = state.selectedDTO.macroTypologyID;
            // eslint-disable-next-line max-len
            state.selectedDTO.label = `${state.groups.filter(gr => gr.id === macroTypology)[0]?.label} - ${state.selectedDTO.selectedListingTypologies.length} ${labels.value.typologies}`;
        } else state.selectedDTO.groupURL = "case";
    }
    const updateListingTypology = (listingTypologies: [IListingTypology]): void => {
        if (state.selectedDTO.selectedListingTypologies.length == 1) {
            if (isNoGroupListingTypology(listingTypologies, state.selectedDTO.selectedListingTypologies[0])) {
                state.selectedDTO.listingTypologyId = state.selectedDTO.macroTypologyID - 1;
            } else {
                state.selectedDTO.listingTypologyId = state.selectedDTO.selectedListingTypologies[0].listingTypologyId;
            }
        } else if (state.selectedDTO.selectedListingTypologies.length > 1) {
            state.selectedDTO.listingTypologyId = state.selectedDTO.selectedListingTypologies[0].macroTypologyID - 1;
        } else state.selectedDTO.listingTypologyId = 0;
    }
    const generateGroups = (listingTypologies: [IListingTypology]): void => {
        listingTypologies.filter(lt => lt.listingTypologyId < 3)
            .forEach(lt => {
                state.groups.push({
                    label: lt.group,
                    url: lt.url,
                    id: lt.macroTypologyID,
                    opened: state.selectedDTO.macroTypologyID == lt.macroTypologyID
                } as ListingGroup);
            });
    }
    const resetSelected = (): void => {
        state.selectedDTO.selectedListingTypologies = [];
    }
    const resetGroupSelected = (): void => {
        state.selectedDTO.groupURL = "";
    }
    const getListingTypologyById = (listingTypologies: [IListingTypology], id: number): IListingTypology => {
        return listingTypologies.find(lt => lt.listingTypologyId === id) ?? defaultSelectedListingTypologies();
    }
    const manageListingTypology = (listingTypologies: [IListingTypology], listingTypology: IListingTypology): void => {
        /* Any case, deselect all */

        if (isAnyListingTypology(listingTypologies, listingTypology) || isNoGroupListingTypology(listingTypologies, listingTypology)) {
            const alreadySelected = isSelected(listingTypology);
            resetSelected();
            resetGroupSelected();

            if (!alreadySelected) {
                addListingTypology(listingTypology);
                state.selectedDTO.macroTypologyID = listingTypology.macroTypologyID;
                state.selectedDTO.macroTypologyIdList = listingTypology.macroTypologyIdList;

                if (isAnyListingTypology(listingTypologies, listingTypology)) {
                    listingTypology.group ? state.selectedDTO.groupURL = groupURL.value : state.selectedDTO.groupURL = "";
                    state.selectedDTO.group = listingTypology.group;
                }
            }
        } else { // click on a not ANY Typology, I don't know if it is already selected  or no
            if (selectedIDS.value.includes(listingTypology.listingTypologyId)) {
                removeListingTypology(listingTypology);
            }
            // select typology of another group
            else if (listingTypology.macroTypologyID !== state.selectedDTO.macroTypologyID) {
                resetSelected();
                addListingTypology(listingTypology);
                state.selectedDTO.macroTypologyID = listingTypology.macroTypologyID;
                state.selectedDTO.macroTypologyIdList = listingTypology.macroTypologyIdList;


                listingTypology.group ?
                    state.selectedDTO.groupURL = groupURL.value :
                    state.selectedDTO.groupURL = "";
            } else {
                /* AVOID TO CLOSE GROUP IF YOU PASS FRON NO TO RESIDENTIAL  */
                listingTypology.group ?
                    state.selectedDTO.groupURL = groupURL.value :
                    state.selectedDTO.groupURL = "";

                state.selectedDTO.macroTypologyID = listingTypology.macroTypologyID;
                state.selectedDTO.macroTypologyIdList = listingTypology.macroTypologyIdList;

                addListingTypology(listingTypology);
            }
            deselectAllAnyOrNoGroupListingTypologies(listingTypologies);
        }

        updateLabelAndIcon(listingTypologies);
        updateListingTypology(listingTypologies);
        confirm(false, undefined, listingTypologies);
    }
    const addListingTypology = (lt: IListingTypology): void => {
        state.selectedDTO.selectedListingTypologies.push(lt);
    }
    const removeListingTypology = (lt: IListingTypology): void => {
        state.selectedDTO.selectedListingTypologies = state.selectedDTO.selectedListingTypologies.filter(l => l.listingTypologyId !== lt.listingTypologyId);
    }
    const deselectAllAnyOrNoGroupListingTypologies = (listingTypologies: [IListingTypology]): void => {
        state.selectedDTO.selectedListingTypologies = state.selectedDTO.selectedListingTypologies.filter(lt =>
            !anyTypologies(listingTypologies).find(anyTypology => anyTypology.id === lt.id) &&
            !noGroupTypologies(listingTypologies).find(noGroupTypology => noGroupTypology.id === lt.id)
        )
    }
    const isSelected = (lt: IListingTypology): boolean => {
        return selectedIDS.value.includes(lt.listingTypologyId);
    }
    const isAnyListingTypology = (listingTypologies: [IListingTypology], listingTypology: IListingTypology): boolean => {
        return anyTypologies(listingTypologies)?.some(lt => lt.listingTypologyId === listingTypology.listingTypologyId);
    }
    const isNoGroupListingTypology = (listingTypologies: [IListingTypology], listingTypology: IListingTypology): boolean => {
        return noGroupTypologies(listingTypologies)?.some(lt => lt.listingTypologyId === listingTypology.listingTypologyId);
    }
    const updateURL = (): void => {
        state.selectedDTO.url = selectedIDS.value.length > 1 ?
            groupURL.value :
            state.selectedDTO.selectedListingTypologies[0]?.url || "";
    }
    const getSelectedTypologyIdList = (): Array<number> => {
        const typologyIdList = [] as Array<number>;
        state.selectedDTO.selectedListingTypologies.forEach((lt: IListingTypology) => lt.typologyIdList.forEach(typologyId => typologyIdList.push(typologyId)));
        return [...typologyIdList];
    }
    const confirm = (hide = false, scroll = false, listingTypologies: [IListingTypology]): void => {
        state.originalLabel = state.selectedDTO.label;
        state.selectedDTO.selectedListingTypologiesIDList = selectedIDS.value;
        state.selectedDTO.selectedTypologiesIDList = getSelectedTypologyIdList();
        updateURL();
        updateLabelAndIcon(listingTypologies);
        setOpenedGroup(state.selectedDTO.groupURL, scroll);
        emits("input-object", state.selectedDTO);
    }
    const anyTypologies = (listingTypologies: [IListingTypology]): Array<IListingTypology> => {
        return listingTypologies?.filter(lt => lt.label === labels.value.allTypologies);
    }
    const noGroupTypologies = (listingTypologies: [IListingTypology]): Array<IListingTypology> => {
        return listingTypologies?.filter(lt => !lt.group);
    }
    const noGroupTypologiesIdList = (listingTypologies: [IListingTypology]): Array<number> => {
        return listingTypologies?.filter(lt => !lt.group).map(lt => lt.listingTypologyId);
    }

    return {
        ...toRefs(state),
        //computed
        labels, selectedLabel,
        //methods
        decodeTextWithEntities,
        updateSelected,
        updateLabelAndIcon,
        generateGroups,
        getListingTypologyById,
        manageListingTypology,
        addListingTypology,
        isSelected,
        confirm,
        noGroupTypologiesIdList,
    }

}